import { render } from "./TaskTypeSelect.vue?vue&type=template&id=48ef957f"
import script from "./TaskTypeSelect.vue?vue&type=script&lang=js"
export * from "./TaskTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\assess_sys_web\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__